<template>
  <div id="inputSearch" :style="`width:${width}`">
    <a class="fa fa-search" @click="togelFocus()"></a>
    <input
      :class="[{ showinput: showinput }]"
      :style="`width:${showinput ? width : '0px'}`"
      type="text"
      ref="inputSearch"
      :placeholder="$t('Search_an_Organization')"
      v-model="value"
      @focus="showinput = true"
      @blur="hide()"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputSearch extends Vue {
  @Prop({ default: false }) readonly showOnly!: boolean;
  @Prop({ default: "200px" }) readonly width!: string;

  private showinput = false;
  private value = "";

  mounted() {
    if (this.showOnly) {
      this.togelFocus();
      this.showinput = true;
    }
  }

  public togelFocus() {
    this.$nextTick(() => {
      const inputSearch: any = this.$refs.inputSearch;
      inputSearch.focus();
    });
  }
  public hide() {
    if (!this.value && !this.showOnly) {
      this.showinput = false;
    }
  }
}
</script>

<style lang="scss" scoped>
#inputSearch {
  position: relative;
  display: flex;
  justify-content: flex-end;
  input {
    outline: none;
    border: 1px solid #e6e1e6;
    border-radius: 15px;
    width: 0px;
    height: 30px;
    padding-left: 0px;
    padding-right: 30px;
    transition: all 0.25s ease-out !important;
  }
  .showinput {
    padding-left: 10px;
  }
  a {
    position: absolute;
    height: 30px;
    width: 30px;
    right: 0px;
    top: 0px;
    padding: 6px 0px 0px 6px;
    color: black;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
